module.exports = __webpack_public_path__ + "static/media/1_5.1061cb8c.png";